var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

/**
 * Gets and returns a list of users assigned to client
 */
export default function getUserList(clientid, sDispatch) {

    const abortController = new AbortController();

      let mounted = true;
      (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/find/client/users?id='+parseInt(clientid), {
          method: 'GET',
          headers: {'Content-Type': 'application/json'},
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {

          if (data.status === "success"){
            sDispatch({
              type: "setUserList",
              payload: { userList: data.users }
            });
          } else {
          }
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
    
    })();
}